<template>
  <BTooltip top>
    <BCopyButton
      :text="historyLink"
      :title="$t('history.url')"
      icon="link"
      icon-button
      @click.stop
    />
    <template #content>
      <div class="save-text">
        {{ $t('general.copyAction.to', { item: $t('history.url') }) }}
      </div>
    </template>
  </BTooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import type { HistoryCommon } from '@/api/openapi';
import { useRouterLink } from '@/composable/router-link';
import BCopyButton from '@/plugins/biscuet-materials/components/molecules/BCopyButton.vue';

type TProps = {
  callTargetId: number;
  uuid: HistoryCommon['uuid'];
};
const props = defineProps<TProps>();

const route = useRoute();
const { fullUrl } = useRouterLink();

const historyLink = computed(() => {
  const currentRouteName = route.name;

  if (currentRouteName === 'AccountDetail') {
    return fullUrl({
      name: currentRouteName,
      params: {
        key: route.params.key,
      },
      query: {
        historyItem: props.uuid,
      },
    });
  } else if (currentRouteName === 'LeadList') {
    return fullUrl({
      name: currentRouteName,
      query: {
        callTargetId: props.callTargetId,
        historyItem: props.uuid,
      },
    });
  } else {
    return fullUrl({
      name: 'Cockpit',
    });
  }
});
</script>
